/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Report_AutoInputs */



/**
* | output |
* | --- |
* | "Wundo writes the report automatically after the meeting." |
*
* @param {Meeting_Report_AutoInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_report_auto = /** @type {((inputs?: Meeting_Report_AutoInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Report_AutoInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Wundo schrijft het verslag automatisch na de meeting.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Wundo rédige le compte rendu automatiquement après la réunion.")
	return /** @type {LocalizedString} */ ("Wundo writes the report automatically after the meeting.")
});